<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
      <!-- Title -->
      <h2 class="text-xl font-semibold text-gray-900">{{ title }}</h2>

      <!-- Description -->
      <p class="text-gray-700 mt-2" [innerHTML]="message"></p>

        <!-- Projected Custom Content -->
        <div class="mt-4">
          <ng-content></ng-content>
        </div>

      <!-- Buttons -->
      <div class="mt-4 flex justify-end space-x-2">
        <button  *ngIf="showConfirmButton" class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400" (click)="onCancel()">
          Cancel
        </button>
        <button
        *ngIf="showConfirmButton"
         class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700" (click)="onConfirm()">
          Confirm
        </button>
      </div>
    </div>
  </div>
